import { createSelector } from 'reselect';

import {
  getFutureOrderingLimitCatering,
  getFutureOrderingLimitCateringDelivery,
  getFutureOrderingLimitPickup,
} from '../selectors';

import { SALE_TYPE } from '../constants/saleType';

/**
 * # getFutureOrderingLimitBySaleType
 */
export default ({ saleType }: { saleType: SALE_TYPE }) =>
  createSelector(
    [
      getFutureOrderingLimitPickup,
      getFutureOrderingLimitCatering,
      getFutureOrderingLimitCateringDelivery,
    ],
    (
      futureOrderingLimitPickup,
      futureOrderingLimitCatering,
      futureOrderingLimitCateringDelivery,
    ): number => {
      const futureOrderingLimitBySaleType: Record<number, number> = {
        [SALE_TYPE.PICKUP]: futureOrderingLimitPickup,
        [SALE_TYPE.CATERING]: futureOrderingLimitCatering,
        [SALE_TYPE.CATERING_DELIVERY]: futureOrderingLimitCateringDelivery,
      };

      const futureOrderingLimit = futureOrderingLimitBySaleType[saleType];

      return futureOrderingLimit;
    },
  );
